export default __webpack_public_path__ + "static/media/spy.785d4fdf.png";